import type {z} from "zod";
import {AddExpedientNoteBody} from "@project/sdk/sales/zod";
import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const addExpedientNoteTitleSchema = requiredStringSchema(
  AddExpedientNoteBody.shape.title,
  noteFieldLabelIds.title,
);
export const addExpedientNoteContentSchema = requiredStringSchema(
  AddExpedientNoteBody.shape.content,
  noteFieldLabelIds.content,
);
export const addExpedientNoteFormSchema = AddExpedientNoteBody.strict().extend({
  title: addExpedientNoteTitleSchema,
  content: addExpedientNoteContentSchema,
});
export type AddExpedientNoteFormPayload = z.output<typeof addExpedientNoteFormSchema>;
export const draftAddExpedientNoteFormSchema = addExpedientNoteFormSchema.partial();
export type DraftAddExpedientNoteFormPayload = z.output<typeof draftAddExpedientNoteFormSchema>;
